export default "* Hvad er en ceremoni?\n* Hvordan tror I jægerstenalderfolket afholdt ceremonier og fester?\n* Hvad skal vi fejre til vores fest?";